import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001";

// Super-admin only. payload: { name, managerId, memberIds[], notes }
export const createNetplusTeamApi = (payload) =>
  axios.post(`${API_BASE_URL}/api/netplus-teams`, payload);

export const updateNetplusTeamApi = (id, payload) =>
  axios.put(`${API_BASE_URL}/api/netplus-teams/${id}`, payload);

// Deactivates (reports are kept).
export const deactivateNetplusTeamApi = (id) =>
  axios.delete(`${API_BASE_URL}/api/netplus-teams/${id}`);

// Combined "Netplus Reports" workbook (.xlsx) built on the server.
export const downloadNetplusReportApi = ({ teamId, from, to } = {}) =>
  axios.get(`${API_BASE_URL}/api/netplus-teams/club-report/export`, {
    params: {
      teamId: teamId || undefined,
      from: from || undefined,
      to: to || undefined,
    },
    responseType: "blob",
  });

// Super-admin Daily Report Summary workbook (.xlsx).
export const downloadDailySummaryApi = (date) =>
  axios.get(`${API_BASE_URL}/api/reports/daily-summary/export`, {
    params: { date: date || undefined },
    responseType: "blob",
  });

// ---- Scan Modem (Netplus Hub) ----
export const scanModemLookupApi = (code) =>
  axios.post(`${API_BASE_URL}/api/netplus/modem-scan/lookup`, { code });
export const scanModemSaveApi = (items, title) =>
  axios.post(`${API_BASE_URL}/api/netplus/modem-scan/sessions`, {
    items: items.map((i) => ({ macId: i.macId, scannedAt: i.scannedAt })),
    title,
  });
export const scanModemListApi = () =>
  axios.get(`${API_BASE_URL}/api/netplus/modem-scan/sessions`);
export const scanModemGetApi = (id) =>
  axios.get(`${API_BASE_URL}/api/netplus/modem-scan/sessions/${id}`);
export const scanModemRecoveredApi = (id) =>
  axios.post(`${API_BASE_URL}/api/netplus/modem-scan/sessions/${id}/recovered`);
export const scanModemHandoverApi = (id, note) =>
  axios.post(`${API_BASE_URL}/api/netplus/modem-scan/sessions/${id}/handover`, {
    note,
  });
export const scanModemExportDraftApi = (items) =>
  axios.post(
    `${API_BASE_URL}/api/netplus/modem-scan/export`,
    { items: items.map((i) => ({ macId: i.macId, scannedAt: i.scannedAt })) },
    { responseType: "blob" },
  );
export const scanModemExportSessionApi = (id) =>
  axios.get(`${API_BASE_URL}/api/netplus/modem-scan/sessions/${id}/export`, {
    responseType: "blob",
  });
